module.exports = __webpack_public_path__ + "static/media/recharging-your-battery@3x.9d24a018.png";